import { useEffect } from 'react';
import moment from 'moment';
import ReactDOMServer from 'react-dom/server';
import { getEmoji, getSentiment } from './utils';

export function useTransformSentimentChartData(rawData = [], setHoveredPoint) {
  function normalizeDate(str) {
    const tzMap = {
      PST: '-08:00',
      PDT: '-07:00',
      MST: '-07:00',
      MDT: '-06:00',
      CST: '-06:00',
      CDT: '-05:00',
      EST: '-05:00',
      EDT: '-04:00'
    };

    const tzMatch = str.match(/\b([A-Z]{3})$/);
    let offset = '';
    if (tzMatch && tzMap[tzMatch[1]]) {
      offset = tzMap[tzMatch[1]];
      str = str.replace(' ' + tzMatch[1], '');
    }

    const dateTimeMatch = str.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2}) ([AP]M)$/);
    if (!dateTimeMatch) return new Date(str); // fallback
    let [, date, hour, minute, second, ampm] = dateTimeMatch;
    hour = parseInt(hour, 10);
    if (ampm === 'PM' && hour !== 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;
    hour = hour.toString().padStart(2, '0');
    const iso = `${date}T${hour}:${minute}:${second}${offset}`;
    return new Date(iso);
  }

  useEffect(() => {
    window.__setHoveredPoint = setHoveredPoint;
  }, []);
  const DistanceBetweenEmojies = 5;
  function groupByDate(arr) {
    const sorted = arr.sort((a, b) => normalizeDate(a.response_date) - normalizeDate(b.response_date));
    const result = {};
    sorted.forEach(item => {
      const d = normalizeDate(item.response_date);
      const key = d.toISOString().substring(0, 10);
      if (!result[key]) result[key] = [];
      result[key].push(item);
    });
    return result;
  }
  const result = [];
  const dateLabels = [];
  const verticalLines = [];
  let groupsData = groupByDate(rawData);
  let xPosition = DistanceBetweenEmojies;

  Object.entries(groupsData).forEach(([groupKey, items]) => {
    items.forEach(dd => {
      result.push({
        y: dd.normalized_score,
        x: xPosition,
        data: dd,
        isDateLabel: false
      });
      xPosition += DistanceBetweenEmojies;
    });
    xPosition += DistanceBetweenEmojies;
    dateLabels.push({
      y: 5.7,
      x: xPosition - 6,
      data: moment(groupKey)?.format('DD/MM/YYYY'),
      isDateLabel: true
    });
    verticalLines.push({
      value: xPosition,
      width: 1,
      color: '#EBEEF0',
      dashStyle: 'dash',
      zIndex: 5
    });
    xPosition += DistanceBetweenEmojies;
  });

  let options = {
    chart: {
      spacing: [0, 0, 0, 0],
      borderWidth: 0,
      height: 260,
      plotBorderWidth: 0,
      type: 'scatter',
      scrollablePlotArea: {
        minWidth: 6000,
        scrollPositionX: 1
      },
      zooming: { type: 'xy' }
    },

    legend: { enabled: false },
    title: { text: ' ' },

    xAxis: {
      gridLineWidth: 0,
      lineWidth: 1,
      lineColor: '#EBEEF0',
      tickLength: 0,
      plotLines: verticalLines,
      labels: {
        enabled: false
      }
    },

    yAxis: {
      lineWidth: 0,
      tickLength: 0,
      gridLineWidth: 1,
      tickPositions: [-1, 0, 1, 2, 3, 4, 5, 6],
      labels: {
        enabled: false
      },
      title: {
        text: ' '
      },
      maxPadding: 0.2
    },

    tooltip: {
      hideDelay: 0,
      useHTML: true,
      fadeOut: 0,
      shared: false,
      animation: false,
      stickOnContact: false,
      backgroundColor: 'transparent',
      padding: 0,
      formatter() {
        if (window.__setHoveredPoint) {
          window.__setHoveredPoint(this.point);
        }
        return `<div id="recent-online-review-feedback-tooltip-container"></div>`;
      }
    },
    plotOptions: {
      series: {
        stickyTracking: false,
        cursor: 'pointer'
      },
      scatter: {
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
              halo: { size: 0 }
            }
          }
        },
        dataLabels: {
          crop: false,
          overflow: 'none',
          enabled: true,
          useHTML: true,
          align: 'center',
          verticalAlign: 'middle',
          formatter: function () {
            if (this.point.isDateLabel) {
              return `<div style="font-weight:400;font-size:13px">${this.point?.data}</div>`;
            }
            return ReactDOMServer.renderToString(
              getEmoji(getSentiment(this.point.y), null, null, this.point?.data?.source)
            );
          },
          style: { textOutline: 'none' }
        }
      }
    },
    series: [
      { data: result, colorByPoint: true },
      {
        data: dateLabels,
        enableMouseTracking: false,
        states: { hover: { enabled: false } },
        tooltip: { enabled: false }
      }
    ],
    marker: { enabled: false },
    credits: { enabled: false },
    exporting: { enabled: false }
  };

  return { options };
}
